import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Page Not Found - DojoTrack</title>
        <meta
          name="description"
          content="The page you are looking for could not be found. Return to DojoTrack's home page to explore our martial arts school management software."
        />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Page Not Found - DojoTrack" />
        <meta
          property="og:description"
          content="The page you are looking for could not be found. Return to DojoTrack's home page."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://dojotrack.com/404" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Page Not Found - DojoTrack" />
        <meta
          name="twitter:description"
          content="The page you are looking for could not be found. Return to DojoTrack's home page."
        />
      </Helmet>
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center bg-white dark:bg-gray-900 py-12">
          <h1 className="text-5xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">
            404
          </h1>
          <h2 className="text-2xl font-semibold mb-2 text-gray-900 dark:text-white">
            Page Not Found
          </h2>
          <p className="mb-6 text-gray-600 dark:text-gray-400">
            Sorry, the page you are looking for does not exist.
          </p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-2 bg-indigo-600 dark:bg-indigo-500 text-white rounded hover:bg-indigo-700 dark:hover:bg-indigo-600 font-semibold transition-colors"
          >
            Go to Home Page
          </button>
        </div>
      </div>
    </>
  );
}
